import { render, staticRenderFns } from "./ProductUpdateImage.vue?vue&type=template&id=e6216e7a&scoped=true&"
import script from "./ProductUpdateImage.vue?vue&type=script&lang=js&"
export * from "./ProductUpdateImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpdateImage.vue?vue&type=style&index=0&id=e6216e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6216e7a",
  null
  
)

export default component.exports